import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";

import { IFilter } from "../../models/shared/ifilter";
import { IApi } from "../../models/shared/iapi";

import { ResponseResult } from "../../models/shared/response-result";
import { BaseDataService } from "./base.data.service";
import { UserApi } from "../../models/apis/user.api";

export class BaseUserService<
  E,
  F extends IFilter<E>,
  A extends IApi<E>,
> extends BaseDataService<E, F, A> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
    public tCreator: new () => E,
  ) {
    super(dbSrv, spinner, http, tCreator);
  }

  login(element: E, loader: boolean = true): Promise<ResponseResult<E, A>> {
    return new Promise((resolve, reject) => {
      this.httpPost(`${this.Url}/login`, element, true, loader).then(
        (response: ResponseResult<E, A>) => {
          if (response.Success) {
            this.setCustomHeaders(response.ObjectResult);
            this.store(response.ObjectResult);
          }
          return resolve(response);
        },
      );
    });
  }

  logout(): Promise<boolean> {
    return this.clear();
  }

  recovery(element: E, loader: boolean = true): Promise<ResponseResult<E, A>> {
    return new Promise((resolve, reject) => {
      this.httpPost(`${this.Url}/recovery`, element, true, loader).then(
        (response: ResponseResult<E, A>) => {
          if (response.Success) {
            this.store(response.ObjectResult);
          }
          return resolve(response);
        },
      );
    });
  }

  logged(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.current().then((r) => {
        this.setCustomHeaders(r);
        return resolve(r != null);
      });
    });
  }

  setCustomHeaders(response: A | E | UserApi) {
    if (response) {
      this.CustomHeaders = this.CustomHeaders.filter(
        (t) => t.Name !== "AuthToken",
      );
      this.CustomHeaders.push({
        Name: "AuthToken",
        Value: (response as UserApi).IdGuid,
      });
    }
  }
}
